import FeatureFlagsReducer from './components/featureFlags/reducer';
import { mfaSlice } from './store/mfa';
import loadingReducer from './store/reducers/loading';
import messagesReducer from './store/reducers/messages';

export const commonReducers = {
  loading: loadingReducer,
  messages: messagesReducer,
  featureFlags: FeatureFlagsReducer,
  mfa: mfaSlice.reducer,
};
